import React, { useState } from "react";

import DepositRecord from "./DepositRecord";
import WithdrawRecord from "./WithdrawRecord";
import EarningRecord from "./EarningRecord";

import "./Records.css";

const Record = () => {
  const [activeTab, setActiveTab] = useState("deposit");

  return (
    <div className="record-page">

      {/* HEADER */}
      <div className="record-header">
        <h2>Records</h2>
        <p>View your transaction history</p>
      </div>


      {/* TABS */}
      <div className="record-tabs">

      <button
  type="button"
  className={
    activeTab === "deposit"
      ? "record-tab active"
      : "record-tab"
  }
  onClick={() => setActiveTab("deposit")}
>
  Deposit Record
</button>

<button
  type="button"
  className={
    activeTab === "withdraw"
      ? "record-tab active"
      : "record-tab"
  }
  onClick={() => setActiveTab("withdraw")}
>
  Withdraw Record
</button>

<button
  type="button"
  className={
    activeTab === "earning"
      ? "record-tab active"
      : "record-tab"
  }
  onClick={() => setActiveTab("earning")}
>
  Earning Record
</button>

      </div>


      {/* PAGE CONTENT */}

      <div className="record-content">

        {activeTab === "deposit" && (
          <DepositRecord />
        )}


        {activeTab === "withdraw" && (
          <WithdrawRecord />
        )}


        {activeTab === "earning" && (
          <EarningRecord />
        )}

      </div>

    </div>
  );
};

export default Record;